// Polyfills -------------------------------------------------------------------

// The order of the promise polyfills is extremely important
import 'core-js/modules/es.promise';
import 'core-js/modules/es.promise.finally';

import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.find-index';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/web.dom-collections.for-each';

import 'url-search-params-polyfill';
import 'whatwg-fetch';
import '@webcomponents/custom-elements';

// Global Menus ----------------------------------------------------------------

import './styles/main.less';
import GlobalMenus from './scripts/global-menus';

// Automatic Initialization ----------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  GlobalMenus.initialize();
});

// -----------------------------------------------------------------------------

//
// Provide the GlobalMenus object as an export.
//
export { GlobalMenus };
export default GlobalMenus;



// WEBPACK FOOTER //
// ./src/index.js